(function() {
  var cardsRoot = document.querySelector('[data-ghost-shop-cards]');
  if (!cardsRoot) return;

  var homeShop = document.querySelector('[data-ghost-home-shop]');
  var showImageLabelTemplate = homeShop
    ? homeShop.getAttribute('data-ghost-home-show-image-label') || 'Show image __NUMBER__'
    : 'Show image __NUMBER__';

  var lightbox = document.querySelector('[data-ghost-home-lightbox]');
  var lightboxImage = document.querySelector('[data-ghost-home-lightbox-image]');
  var lightboxCounter = document.querySelector('[data-ghost-home-lightbox-counter]');
  var lightboxThumbs = document.querySelector('[data-ghost-home-lightbox-thumbs]');
  var lightboxClose = document.querySelector('[data-ghost-home-lightbox-close]');
  var lightboxPrev = document.querySelector('[data-ghost-home-lightbox-prev]');
  var lightboxNext = document.querySelector('[data-ghost-home-lightbox-next]');
  var lightboxStage = document.querySelector('[data-ghost-home-lightbox-stage]');
  var lightboxImages = [];
  var lightboxIndex = 0;
  var focus = window.GhostModalFocus;

  function showImageLabel(index) {
    return showImageLabelTemplate.replace('__NUMBER__', String(index + 1));
  }

  function thumbUrlFromFull(url) {
    if (!url) return url;
    if (url.indexOf('cdn.shopify.com') !== -1) {
      return url.replace(/width=\d+/i, 'width=240').replace(/_\d+x(\.|$)/, '_240x$1');
    }
    return url;
  }

  function bindCardThumb(card, thumb) {
    thumb.addEventListener('click', function(event) {
      event.stopPropagation();
      var imageNode = card.querySelector('[data-ghost-card-image]');
      var imageUrl = thumb.getAttribute('data-image-url');
      if (!imageNode || !imageUrl) return;

      card.querySelectorAll('[data-ghost-card-thumb]').forEach(function(item) {
        item.classList.remove('is-active');
      });
      thumb.classList.add('is-active');
      imageNode.src = imageUrl;
      imageNode.srcset = '';
    });
  }

  function ensureCardThumbs(card, urls) {
    if (!Array.isArray(urls) || urls.length <= 1) return;

    var thumbsWrap = card.querySelector('[data-ghost-card-thumbs]');
    if (thumbsWrap && thumbsWrap.children.length > 0) return;

    var media = card.querySelector('[data-ghost-card-lightbox-trigger]');
    if (!media) return;

    if (!thumbsWrap) {
      thumbsWrap = document.createElement('div');
      thumbsWrap.className = 'ghost-shop-card__thumbs';
      thumbsWrap.setAttribute('data-ghost-card-thumbs', '');
      media.appendChild(thumbsWrap);
    }

    thumbsWrap.hidden = false;
    thumbsWrap.innerHTML = '';

    urls.slice(0, 4).forEach(function(url, index) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'ghost-shop-card__thumb' + (index === 0 ? ' is-active' : '');
      button.setAttribute('data-ghost-card-thumb', '');
      button.setAttribute('data-image-url', url);
      button.setAttribute('aria-label', showImageLabel(index));
      button.innerHTML = '<img src="' + thumbUrlFromFull(url).replace(/"/g, '&quot;') + '" alt="" width="36" height="36" loading="lazy">';
      bindCardThumb(card, button);
      thumbsWrap.appendChild(button);
    });
  }

  function updateCardGallery(card, urls) {
    if (!Array.isArray(urls) || !urls.length) return;

    var galleryNode = card.querySelector('[data-ghost-card-gallery]');
    if (galleryNode) {
      galleryNode.textContent = JSON.stringify(urls);
    }

    ensureCardThumbs(card, urls);

    card.querySelectorAll('[data-ghost-card-thumb]').forEach(function(item, index) {
      item.classList.toggle('is-active', index === 0);
    });
  }

  function parseGallery(card) {
    var node = card.querySelector('[data-ghost-card-gallery]');
    if (!node) return [];
    try {
      var parsed = JSON.parse(node.textContent || '[]');
      return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
    } catch (error) {
      return [];
    }
  }

  function renderLightboxThumbs() {
    if (!lightboxThumbs) return;
    lightboxThumbs.innerHTML = '';

    lightboxImages.forEach(function(url, index) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = index === lightboxIndex ? 'is-active' : '';
      button.setAttribute('aria-label', showImageLabel(index));
      button.innerHTML = '<img src="' + thumbUrlFromFull(url).replace(/"/g, '&quot;') + '" alt="">';
      button.addEventListener('click', function() {
        lightboxIndex = index;
        updateLightbox();
      });
      lightboxThumbs.appendChild(button);
    });
  }

  function updateLightbox() {
    if (!lightboxImage || !lightboxImages.length) return;
    lightboxImage.src = lightboxImages[lightboxIndex];
    if (lightboxCounter) {
      lightboxCounter.textContent = (lightboxIndex + 1) + ' / ' + lightboxImages.length;
    }
    renderLightboxThumbs();
    if (lightboxPrev) lightboxPrev.hidden = lightboxImages.length <= 1;
    if (lightboxNext) lightboxNext.hidden = lightboxImages.length <= 1;
  }

  function openLightbox(card) {
    lightboxImages = parseGallery(card);
    if (!lightboxImages.length) {
      var imageNode = card.querySelector('[data-ghost-card-image]');
      if (imageNode && imageNode.src) {
        lightboxImages = [imageNode.src];
      }
    }
    if (!lightboxImages.length || !lightbox) return;

    var activeThumb = card.querySelector('[data-ghost-card-thumb].is-active');
    lightboxIndex = 0;
    if (activeThumb) {
      var activeUrl = activeThumb.getAttribute('data-image-url');
      var matchIndex = lightboxImages.indexOf(activeUrl);
      if (matchIndex >= 0) lightboxIndex = matchIndex;
    }

    updateLightbox();
    if (focus) focus.rememberFocus();
    lightbox.hidden = false;
    lightbox.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    if (focus) focus.focusInitial(lightboxStage || lightbox, '[data-ghost-home-lightbox-close]');
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.hidden = true;
    lightbox.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (focus) focus.restoreFocus();
  }

  function stepLightbox(delta) {
    if (!lightboxImages.length) return;
    lightboxIndex = (lightboxIndex + delta + lightboxImages.length) % lightboxImages.length;
    updateLightbox();
  }

  if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
  if (lightboxPrev) lightboxPrev.addEventListener('click', function() { stepLightbox(-1); });
  if (lightboxNext) lightboxNext.addEventListener('click', function() { stepLightbox(1); });
  if (lightbox) {
    lightbox.addEventListener('click', function(event) {
      if (event.target === lightbox) closeLightbox();
    });
  }

  document.addEventListener('keydown', function(event) {
    if (!lightbox || lightbox.hidden) return;
    if (event.key === 'Escape') closeLightbox();
    if (event.key === 'ArrowLeft') stepLightbox(-1);
    if (event.key === 'ArrowRight') stepLightbox(1);
    if (focus) focus.trapTab(event, lightboxStage || lightbox);
  });

  var hoveredCardId = null;
  var cartVariantIds = new Set();
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function syncCardGalleryFromState(card) {
    var thumbsWrap = card.querySelector('[data-ghost-card-thumbs]');
    if (thumbsWrap && thumbsWrap.children.length > 0) return;

    var galleryUrls = parseGallery(card);
    if (galleryUrls.length > 1) {
      ensureCardThumbs(card, galleryUrls);
    }
  }

  function getActiveVariantButton(card) {
    return card.querySelector('[data-ghost-variant-button].is-active')
      || card.querySelector('[data-ghost-variant-button]');
  }

  function updateBuyButton(card) {
    var buyButton = card.querySelector('[data-ghost-buy-button]');
    var variantInput = card.querySelector('[data-ghost-variant-input]');
    if (!buyButton || !variantInput) return;

    var activeVariant = getActiveVariantButton(card);
    var variantId = String(variantInput.value || '');
    var available = !activeVariant || activeVariant.getAttribute('data-available') === 'true';
    var labelAvailable = buyButton.getAttribute('data-label-available') || 'Add to cart';
    var labelInCart = buyButton.getAttribute('data-label-in-cart') || 'Already in your cart';
    var labelSoldOut = buyButton.getAttribute('data-label-sold-out') || 'Sold out';
    var inCart = variantId && cartVariantIds.has(variantId);

    if (!available) {
      buyButton.disabled = true;
      buyButton.textContent = labelSoldOut;
      buyButton.classList.remove('is-in-cart');
      return;
    }

    buyButton.disabled = false;

    if (inCart) {
      buyButton.textContent = labelInCart;
      buyButton.classList.add('is-in-cart');
      return;
    }

    buyButton.textContent = labelAvailable;
    buyButton.classList.remove('is-in-cart');
  }

  function syncCartVariants(cart) {
    cartVariantIds.clear();

    if (cart && Array.isArray(cart.items)) {
      cart.items.forEach(function(item) {
        cartVariantIds.add(String(item.variant_id));
      });
    }

    cardsRoot.querySelectorAll('[data-ghost-shop-card]').forEach(updateBuyButton);
  }

  cardsRoot.querySelectorAll('[data-ghost-shop-card]').forEach(function(card) {
    var shell = card.querySelector('[data-ghost-card-shell]');
    var cardId = card.getAttribute('data-card-id');
    var variantButtons = card.querySelectorAll('[data-ghost-variant-button]');
    var variantInput = card.querySelector('[data-ghost-variant-input]');
    var priceNode = card.querySelector('[data-ghost-price]');
    var compareNode = card.querySelector('[data-ghost-compare-price]');
    var imageNode = card.querySelector('[data-ghost-card-image]');

    if (shell && canHover) {
      shell.addEventListener('mouseenter', function() {
        hoveredCardId = cardId;
        updateHoverStates();
      });
      shell.addEventListener('mouseleave', function() {
        hoveredCardId = null;
        updateHoverStates();
      });
    }

    variantButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        if (button.disabled || button.classList.contains('ghost-shop-card__variant--solo')) return;
        selectVariant(card, button);
      });
    });

    if (variantButtons.length === 1) {
      selectVariant(card, variantButtons[0]);
    } else if (variantButtons.length > 1) {
      var activeButton = card.querySelector('[data-ghost-variant-button].is-active') || variantButtons[0];
      selectVariant(card, activeButton);
    } else {
      syncCardGalleryFromState(card);
    }

    card.querySelectorAll('[data-ghost-card-thumb]').forEach(function(thumb) {
      bindCardThumb(card, thumb);
    });

    var media = card.querySelector('[data-ghost-card-lightbox-trigger]');
    if (media) {
      media.addEventListener('click', function(event) {
        if (event.target.closest('[data-ghost-card-thumb]')) return;
        openLightbox(card);
      });
      media.addEventListener('keydown', function(event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openLightbox(card);
        }
      });
    }

    function selectVariant(cardEl, button) {
      variantButtons.forEach(function(item) {
        item.classList.remove('is-active');
        item.setAttribute('aria-pressed', 'false');
      });

      button.classList.add('is-active');
      button.setAttribute('aria-pressed', 'true');

      if (variantInput) {
        variantInput.value = button.getAttribute('data-variant-id');
      }

      var compareInput = cardEl.querySelector('[data-ghost-compare-at-input]');
      if (compareInput) {
        compareInput.value = button.getAttribute('data-compare-at-cents') || '';
      }

      if (priceNode) {
        priceNode.textContent = button.getAttribute('data-price') || '';
      }

      if (compareNode) {
        var comparePrice = button.getAttribute('data-compare-price');
        if (comparePrice) {
          compareNode.textContent = comparePrice;
          compareNode.hidden = false;
        } else {
          compareNode.textContent = '';
          compareNode.hidden = true;
        }
      }

      updateBuyButton(cardEl);

      if (imageNode) {
        var imageUrl = button.getAttribute('data-image-url');
        if (imageUrl) {
          imageNode.src = imageUrl;
          imageNode.srcset = '';
          imageNode.setAttribute('data-ghost-card-product-image', imageUrl);
        }
      }

      var galleryData = button.getAttribute('data-gallery-urls');
      if (galleryData) {
        try {
          updateCardGallery(cardEl, JSON.parse(galleryData));
        } catch (error) {}
      }

      var swatch = button.getAttribute('data-swatch');
      if (shell && swatch && !button.classList.contains('ghost-shop-card__variant--solo')) {
        shell.style.setProperty('--ghost-card-accent', swatch);
        shell.style.setProperty('--ghost-card-accent-dim', swatch + '33');
        shell.style.setProperty('--ghost-card-accent-border', swatch + '73');
      }
    }
  });

  function updateHoverStates() {
    cardsRoot.querySelectorAll('[data-ghost-card-shell]').forEach(function(shell) {
      var card = shell.closest('[data-ghost-shop-card]');
      var cardId = card ? card.getAttribute('data-card-id') : null;
      var isHovered = hoveredCardId === cardId;
      var otherHovered = hoveredCardId !== null && hoveredCardId !== cardId;

      shell.classList.toggle('is-hovered', isHovered);
      shell.classList.toggle('is-dimmed', otherHovered);
    });
  }

  cardsRoot.querySelectorAll('[data-ghost-buy-button]').forEach(function(button) {
    if (!button.getAttribute('data-label-available')) {
      button.setAttribute('data-label-available', button.textContent.trim());
    }
    if (!button.getAttribute('data-label-in-cart')) {
      button.setAttribute('data-label-in-cart', 'Already in your cart');
    }
    if (!button.getAttribute('data-label-sold-out')) {
      button.setAttribute('data-label-sold-out', 'Sold out');
    }
  });

  document.addEventListener('ghost:cart:updated', function(event) {
    syncCartVariants(event.detail && event.detail.cart ? event.detail.cart : null);
  });

  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(function(response) {
      return response.ok ? response.json() : null;
    })
    .then(syncCartVariants)
    .catch(function() {});

  var compareRoot = document.querySelector('[data-ghost-compare]');
  if (compareRoot) {
    var toggle = compareRoot.querySelector('[data-ghost-compare-toggle]');
    var panel = compareRoot.querySelector('[data-ghost-compare-panel]');
    var panelInner = compareRoot.querySelector('[data-ghost-compare-panel-inner]');

    function setComparePanelHeight(height) {
      panel.style.maxHeight = height + 'px';
    }

    function openComparePanel() {
      panel.hidden = false;
      setComparePanelHeight(panelInner ? panelInner.scrollHeight : panel.scrollHeight);
      panel.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
    }

    function closeComparePanel() {
      setComparePanelHeight(panelInner ? panelInner.scrollHeight : panel.scrollHeight);
      window.requestAnimationFrame(function() {
        setComparePanelHeight(0);
        panel.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      });
    }

    if (toggle && panel) {
      panel.addEventListener('transitionend', function(event) {
        if (event.propertyName !== 'max-height') return;
        if (!panel.classList.contains('is-open')) {
          panel.hidden = true;
        }
      });

      toggle.addEventListener('click', function() {
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          closeComparePanel();
          return;
        }
        openComparePanel();
      });

      window.addEventListener('resize', function() {
        if (toggle.getAttribute('aria-expanded') !== 'true') return;
        setComparePanelHeight(panelInner ? panelInner.scrollHeight : panel.scrollHeight);
      });
    }
  }
})();
